.placeholder {
  fill: var(--color-white);
}
